import { Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { FeatureAuthForm } from 'system/components/feature-auth/form';
import { CommonFeatureAuthCrumbs } from 'system/constants/common-feature-auth-crumbs';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { FeatureAuth } from 'shell/models/feature-auth';
import { transformFeatureAuth } from 'system/components/feature-auth/utils/transform-feature-auth';
import { noop } from 'shell/utils/noop';

const FeatureAuthEdit = (): React.ReactElement => {
  const params = useParams();

  const [featureAuth] = useHttpFetch<HttpResponse<FeatureAuth>, FeatureAuthForm>(
    `${__MANAGEMENT_API_URL__}/tipo-feature-auth/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformFeatureAuth,
    }
  );

  const navigate = useNavigate();

  const loading = featureAuth.isLoading || featureAuth.pristine || featureAuth.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonFeatureAuthCrumbs, { name: 'Dettaglio Autorizzazione' }]} />
      {loading ? null : (
        <Form
          title="Dettaglio Autorizzazione"
          onOk={noop}
          initialValues={featureAuth.data as FeatureAuthForm}
          onCancel={() => {
            navigate('/sistema/feature-auth');
          }}
          disabled
          redirectPath={`feature-auth/dettaglio/${
            (featureAuth.data as FeatureAuthForm)?.code || ''
          }`}
        />
      )}
    </Fragment>
  );
};

FeatureAuthEdit.displayName = 'Feature Auth detail page component';

export default FeatureAuthEdit;
